import Vue from 'vue'
import '@/plugins/axios'
import App from '@/views/App.vue'
import router from '@/routes'
import store from '@/libs/store'
import '@/registerServiceWorker'
import vuetify from '@/plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import {VueMasonryPlugin} from 'vue-masonry'
import Vidle from 'v-idle'

window.Vue = Vue;

Vue.config.productionTip = false
import PluginsAndLibraries from '@/configs/pluginsAndLibraries'
Vue.use(PluginsAndLibraries, router, store)
Vue.use(VueMasonryPlugin)
Vue.use(Vidle)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
